// Get confirmed orders for logistics
export const GET_LOGISTICS_ORDERS = "GET_LOGISTICS_ORDERS";

// Get sent to logistics orders
export const GET_SENT_LOGISTICS_ORDERS = "GET_SENT_LOGISTICS_ORDERS";

// Send order to logistics
export const SEND_TO_LOGISTICS = "SEND_TO_LOGISTICS";

// Update order after sending to logistics
export const UPDATE_LOGISTICS_ORDER = "UPDATE_LOGISTICS_ORDER";

// Set loading state
export const SET_LOGISTICS_LOADING = "SET_LOGISTICS_LOADING";

// Set tracking data
export const SET_TRACKING_DATA = "SET_TRACKING_DATA";

// Clear tracking data
export const CLEAR_TRACKING_DATA = "CLEAR_TRACKING_DATA";

// Delete order from logistics
export const DELETE_LOGISTICS_ORDER = "DELETE_LOGISTICS_ORDER";
